"use strict";

import React, {Component} from "react"

import Select from "react-select";

import _ from "lodash";

import {apiPath, countryOptions, platformOptions, arrayToSelectOptions} from "../../const";
import Row from "../../component/Layout/Row";
import Col from "../../component/Layout/Col";
import ContentContainer from "../../component/Template/ContentContainer";
import PropTypes from "prop-types";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {getRequest} from "../../service/api/request";

const FilterContext = React.createContext('filter');

class FilterProvider extends Component {

    constructor(props) {
        super(props);

        this.state = {
            selectedCountries: JSON.parse(localStorage.getItem("FilterContext.selectedCountries") || "[]"),
            selectedPlatforms: [], //JSON.parse(localStorage.getItem("FilterContext.selectedPlatforms") || "[]"),
            selectedVideoPackages: JSON.parse(localStorage.getItem("FilterContext.selectedVideoPackages") || "[]"),
            selectedChannels: JSON.parse(localStorage.getItem("FilterContext.selectedChannels") || "[]"),
            selectedGenreGroups: JSON.parse(localStorage.getItem("FilterContext.selectedGenreGroups") || "[]"),
            selectedPrimaryGenres: JSON.parse(localStorage.getItem("FilterContext.selectedPrimaryGenres") || "[]"),
            selectedGenreTags: JSON.parse(localStorage.getItem("FilterContext.selectedGenreTags") || "[]"),
            selectedSchedule: JSON.parse(localStorage.getItem("FilterContext.selectedSchedule") || "\"CURRENT\""),
            filterTimestamp: (new Date).getTime(),

            setSelectedCountries: (selectedCountries) => {
                    this.setState({selectedCountries});
                    localStorage.setItem("FilterContext.selectedCountries", JSON.stringify(selectedCountries));
                },
            setSelectedPlatforms: (selectedPlatforms) => {
                    this.setState({selectedPlatforms});
                    localStorage.setItem("FilterContext.selectedPlatforms", JSON.stringify(selectedPlatforms));
                },
            setSelectedVideoPackages: (selectedVideoPackages) => {
                    this.setState({selectedVideoPackages});
                    localStorage.setItem("FilterContext.selectedVideoPackages", JSON.stringify(selectedVideoPackages));
                },
            setSelectedChannels: (selectedChannels) => {
                this.setState({selectedChannels});
                localStorage.setItem("FilterContext.selectedChannels", JSON.stringify(selectedChannels));
            },
            setSelectedGenreGroups: (selectedGenreGroups) => {
                    this.setState({selectedGenreGroups});
                    localStorage.setItem("FilterContext.selectedGenreGroups", JSON.stringify(selectedGenreGroups));
                },
            setSelectedPrimaryGenres: (selectedPrimaryGenres) => {
                    this.setState({selectedPrimaryGenres});
                    localStorage.setItem("FilterContext.selectedPrimaryGenres", JSON.stringify(selectedPrimaryGenres));
                },
            setSelectedGenreTags: (selectedGenreTags) => {
                this.setState({selectedGenreTags});
                localStorage.setItem("FilterContext.selectedGenreTags", JSON.stringify(selectedGenreTags));
            },
            setSelectedSchedule: (e) => {
                    const selectedSchedule = e.target.value;
                    this.setState({selectedSchedule});
                    localStorage.setItem("FilterContext.selectedSchedule", JSON.stringify(selectedSchedule));
                },
            setFilterTimestamp: (filterTimestamp) => {
                this.setState({filterTimestamp});
            },
        };
    }

    render() {
        return (
            <FilterContext.Provider value={this.state}>
                {this.props.children}
            </FilterContext.Provider>
        );
    };
}

const FilterConsumer = FilterContext.Consumer;

class FilterSelectors extends Component {

    static propTypes = {
        countryOptions : PropTypes.arrayOf(PropTypes.object),
        platformOptions : PropTypes.arrayOf(PropTypes.object),
        videoPackageOptions : PropTypes.arrayOf(PropTypes.object),
    };

    static defaultProps = {
        countryOptions : countryOptions,
        platformOptions : platformOptions,
    };

    constructor(props) {
        super(props);
        this.state = {
            countryOptions : props.countryOptions || countryOptions,
            platformOptions : props.platformOptions || platformOptions,
            videoPackageOptions : [],
        }
    }

    componentDidMount() {
        const subscriptionPackageNameByVideoPackageIdApi  = apiPath + "/subscriptionPackageNameByVideoPackageId";
        getRequest(subscriptionPackageNameByVideoPackageIdApi,{})
            .then(response => {
                this.setState({
                    videoPackageOptions: Object.entries(response.entity).map(([key, value]) => ({ value: key, label: value })),
                });
            })
    }

    render() {
        const { countryOptions, platformOptions, videoPackageOptions } = this.state;

        return (
            <FilterConsumer>
                {context =>
                    <FilterSelectorsComponent
                        countryOptions={countryOptions}
                        platformOptions={platformOptions}
                        videoPackageOptions={videoPackageOptions}
                        filterContext={context}
                    />
                }
            </FilterConsumer>
        );
    };

}

class FilterSelectorsComponent extends Component {

    static propTypes = {
        countryOptions : PropTypes.arrayOf(PropTypes.object),
        platformOptions : PropTypes.arrayOf(PropTypes.object),
        videoPackageOptions : PropTypes.arrayOf(PropTypes.object),
        filterContext : PropTypes.object,
    };

    static defaultProps = {
        countryOptions : countryOptions,
        platformOptions : platformOptions,
        filterContext: {},
    };

    constructor(props) {
        super(props);
        this.state = {
            filterContext: props.filterContext,
            channelsMap : {},
            channelOptions : [],
            channelsLoading : true,
            genreGroupPrimaryMap: {},
            genreGroupTagsMap: {},
            genreGroupOptions : [],
            genreGroupPrimaryOptions : [],
            genreGroupTagsOptions : [],
            genresLoading: true,
        }

        this.applyFilter = this.applyFilter.bind(this);
        this.setSelectedGenreGroups = this.setSelectedGenreGroups.bind(this);
    }

    componentDidMount() {
        this.fetchGenreData();
        this.fetchChannelData();
    }

    fetchGenreData() {
        const { filterContext, genreGroupPrimaryMap, genreGroupTagsMap } = this.state;
        this.setState({ genresLoading: true });

        let genreGroupPrimaryMapLoading = true;
        let genreGroupTagsMapLoading = true;


        const genreGroupPrimaryMapApiPath = apiPath + "/enrichedVideos/search/findAllGenreGroupsAndPrimaries";

        getRequest(
            genreGroupPrimaryMapApiPath,
            {}
        ).then(response => {
            genreGroupPrimaryMapLoading = false;
            this.setState({
                genreGroupPrimaryMap: response.entity,
                genreGroupOptions: arrayToSelectOptions(Object.keys(response.entity).filter((value, index, self) => self.indexOf(value) === index).sort()),
                genreGroupPrimaryOptions: arrayToSelectOptions((filterContext.selectedGenreGroups || []).flatMap(g => response.entity[g.value]).filter((value, index, self) => self.indexOf(value) === index).sort()),
                genresLoading: genreGroupPrimaryMapLoading || genreGroupTagsMapLoading,
            });
        });


        const genreGroupTagsMapApiPath = apiPath + "/enrichedVideos/search/findAllGenreGroupsAndTags";

        getRequest(
            genreGroupTagsMapApiPath,
            {}
        ).then(response => {
            genreGroupTagsMapLoading = false;
            this.setState({
                genreGroupTagsMap: response.entity,
                genreGroupOptions: arrayToSelectOptions(Object.keys(response.entity).filter((value, index, self) => self.indexOf(value) === index).sort()),
                genreGroupTagsOptions: arrayToSelectOptions((filterContext.selectedGenreGroups || []).flatMap(g => response.entity[g.value]).filter((value, index, self) => self.indexOf(value) === index).sort()),
                genresLoading: genreGroupPrimaryMapLoading || genreGroupTagsMapLoading,
            });
        });
    }

    setSelectedGenreGroups(selectedGenreGroups) {
        const { filterContext, genreGroupPrimaryMap, genreGroupTagsMap } = this.state;
        filterContext.setSelectedGenreGroups(selectedGenreGroups);
        if (selectedGenreGroups && selectedGenreGroups.length > 0) {
            this.setState({
                genreGroupPrimaryOptions : arrayToSelectOptions(selectedGenreGroups.flatMap(g => genreGroupPrimaryMap[g.value]).filter((value, index, self) => self.indexOf(value) === index).sort()),
                genreGroupTagsOptions : arrayToSelectOptions(selectedGenreGroups.flatMap(g => genreGroupTagsMap[g.value]).filter((value, index, self) => self.indexOf(value) === index).sort()),
            });
        } else {
            filterContext.setSelectedPrimaryGenres([]);
            filterContext.setSelectedGenreTags([]);
            this.setState({
                genreGroupPrimaryOptions : [],
                genreGroupTagsOptions : [],
            });
        }
    }

    fetchChannelData() {
        const { filterContext, channelOptions } = this.state;
        this.setState({ channelsLoading: true });

        const channelsApiPath = apiPath + "/enrichedVideos/search/findAllChannels";

        getRequest(
            channelsApiPath,
            {}
        ).then(response => {
            let options = [];

            Object.keys(response.entity).forEach(
                tag => options.push({
                    value: tag,
                    label: response.entity[tag].map(ch => ch.channelNumber + " " + ch.channelName + " (" + ch.channelTag + ")").join(" / "),
                })
            );

            options = _.orderBy(options, item => parseInt(item.label.split(" ")[0]));

            this.setState({
                channelsMap: response.entity,
                channelOptions: options,
                channelsLoading: false,
            });
        });
    }

    applyFilter() {
        const { filterContext } = this.state;
        filterContext.setFilterTimestamp((new Date).getTime());
    }

    render() {
        const { countryOptions, videoPackageOptions } = this.props;
        const { channelOptions, channelsLoading, genreGroupOptions, genreGroupPrimaryOptions, genreGroupTagsOptions, genresLoading } = this.state;

        return (
            <FilterConsumer>
                {context =>
                    <ContentContainer>
                        <Row>
                            <Col md="11" xs="12">
                                <Row>
                                    <Col md="3" xs="12">
                                        <Select value={context.selectedCountries}
                                                onChange={context.setSelectedCountries}
                                                options={countryOptions}
                                                placeholder="Countries..."
                                                isMulti
                                                isSearchable
                                        />
                                    </Col>
                                    <Col md="3" xs="12">
                                        <Select value={context.selectedVideoPackages}
                                                onChange={context.setSelectedVideoPackages}
                                                options={videoPackageOptions}
                                                placeholder="Packages..."
                                                isMulti
                                                isSearchable
                                        />
                                    </Col>
                                    <Col md="3" xs="12">
                                        <Select value={context.selectedChannels}
                                                onChange={context.setSelectedChannels}
                                                options={channelOptions}
                                                placeholder="Channels..."
                                                isMulti
                                                isSearchable
                                                isDisabled={channelsLoading}
                                        />
                                    </Col>
                                    <Col md="3" xs="12">
                                        <Row>
                                            <Col sm="6" xs="12">
                                                <div className="radio">
                                                    <label className="text-bold">
                                                        <input type="radio" value="CURRENT"
                                                               checked={context.selectedSchedule === 'CURRENT'}
                                                               onChange={context.setSelectedSchedule} />
                                                        <span className="text-bold">Current</span>
                                                    </label>
                                                </div>
                                            </Col>
                                            <Col sm="6" xs="12">
                                                <div className="radio">
                                                    <label>
                                                        <input type="radio" value="FUTURE"
                                                               checked={context.selectedSchedule === 'FUTURE'}
                                                               onChange={context.setSelectedSchedule} />
                                                        <span className="text-bold">Future</span>
                                                    </label>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md="3" xs="12">
                                        <Select value={context.selectedGenreGroups}
                                                onChange={this.setSelectedGenreGroups}
                                                options={genreGroupOptions}
                                                placeholder="Genre Groups..."
                                                isMulti
                                                isSearchable
                                                isDisabled={genresLoading}
                                        />
                                    </Col>
                                    <Col md="3" xs="12">
                                        <Select value={context.selectedPrimaryGenres}
                                                onChange={context.setSelectedPrimaryGenres}
                                                options={genreGroupPrimaryOptions}
                                                placeholder="Primary Genres..."
                                                isMulti
                                                isSearchable
                                                isDisabled={genresLoading}
                                        />
                                    </Col>
                                    <Col md="3" xs="12">
                                        <Select value={context.selectedGenreTags}
                                                onChange={context.setSelectedGenreTags}
                                                options={genreGroupTagsOptions}
                                                placeholder="Tags..."
                                                isMulti
                                                isSearchable
                                                isDisabled={genresLoading}
                                        />
                                    </Col>
                                    <Col md="3" xs="12">
                                        <div className="text-left">
                                            <button className="btn btn-info" onClick={this.applyFilter}>
                                                { <FontAwesomeIcon icon="filter" size="2x"/> }
                                            </button>
                                        </div>
                                    </Col>
                                </Row>
                            </Col>
                            <Col md="1" xs="12">
                                <Row>
                                    {/*<div className="text-right">*/}
                                    {/*    <form name='logout' action='/logout' method='POST'>*/}
                                    {/*        <button className="btn btn-danger">*/}
                                    {/*            { <FontAwesomeIcon icon="sign-out-alt" size="2x"/> }*/}
                                    {/*        </button>*/}
                                    {/*    </form>*/}
                                    {/*</div>*/}
                                </Row>
                            </Col>
                        </Row>
                    </ContentContainer>
                }
            </FilterConsumer>
        );
    };

}

export {
    FilterProvider,
    FilterConsumer,
    FilterSelectors,
};
